function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFAF20",
  transform: "translate(0 -1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34.286,
  height: 45.714,
  x: 4.571,
  y: 1,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M31.429 28.714c1.184 0 2.142.96 2.142 2.143V48a2.143 2.143 0 0 1-2.142 2.143H2.857A2.143 2.143 0 0 1 .714 48V30.857c0-1.183.959-2.143 2.143-2.143H31.43zm0-23.571c1.184 0 2.142.96 2.142 2.143v17.143a2.143 2.143 0 0 1-2.142 2.142H2.857A2.143 2.143 0 0 1 .714 24.43V7.286c0-1.183.959-2.143 2.143-2.143H31.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.857 31.571H30.43a1 1 0 0 1 1 1v6.572a1 1 0 0 1-1 1H3.857a1 1 0 0 1-1-1V32.57a1 1 0 0 1 1-1zM14.286 9.43h16.363M14.286 13h16.363m-16.363 4.286h16.363M3.57 47.333h27.143m-7.14-25.047h7.142m-27.143 0H20m3.571 22.143h7.143m-27.143 0H20"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.857 13c1.973 0 3.572 1.919 3.572 4.286H4.286C4.286 14.919 5.884 13 7.857 13zm0-4.286a2.144 2.144 0 1 1-.001 4.288 2.144 2.144 0 0 1 .001-4.288z"
}));

var SvgPlasticCnhIcon = function SvgPlasticCnhIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlasticCnhIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plastic_cnh_icon.7c810052.svg";
export { ForwardRef as ReactComponent };